export const getServiceAnnouncementFrag = `
    id
    serviceId
    dateFrom
    workData {
        ... on WorkDataServiceAnnouncementObject {
            id
            serviceId
            typeId
            formId
            workId
            assignedAt
            sequenceNumber
            createdAt
            type {
                id
                name
            }
            latestValueId
            latestValue {
                id
                state
                dateOfExpression
                content
            }
        }
    }
`;
